import styled from 'styled-components';
export const MessageWrapper = styled.div`
	&.change {
		width: 100%;
	}
	&.user {
		align-self: flex-end;
		& + .user {
			margin: 30px 0;
		}
	}
	&.server {
		align-self: flex-start;
		margin: 30px 0;
		&.form {
			margin-bottom: 60px;
		}
	}
	& > .loading {
		padding: 10px 21px;
	}
	& > .server-message-suggestions {
		& > .server-message {
			border: 1px solid #acd5ff;
			color: #191919;
			border-radius: 0px 18px 18px 28px;
			&.expand {
				width: calc(100vw - 244px);
				padding: 43px 60px;
				border-radius: 20px;

				&.sizeChange {
					padding: 24px 16px;
					width: calc(100vw - 68px);
					position: relative;
				}
			}
		}
		&.change {
			display: flex;
			justify-content: space-between;
			& > .server-message {
				max-width: 360px;
			}
			& > .suggestions {
				align-self: flex-end;
				display: block;
			}
		}
		& > .suggestions {
			margin-top: 23px;
			&.change {
				margin-top: 0;
			}
			display: flex;
			justify-content: flex-end;
			& > button {
				width: fit-content;
				padding: 8px 12px;
				border-radius: 20px;
				border: 0.498px solid #3e8bd1;
				background: #0174e7;
				color: #fff;
				font-family: var(--fontFamily);
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
				line-height: 11.951px;
				cursor: pointer;
				width: 164px;
				height: 37px;
			}
		}
	}
	& > .server-message-suggestions > .server-message,
	& > .user-message {
		width: fit-content;
		background: #fff;
		font-family: var(--fontFamily);
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;

		&.user-message {
			background: #e6f1fd;
			border-radius: 18px 0px 28px 18px;
			max-width: 424px;
			word-wrap: anywhere;
		}
		padding: 10px 21px;
	}
`;
